// TODO - this file is useful only until we have the breathing room to evaluate graphql clients 2018-03-09

// util
import { stringify, Enum } from 'util/formatters/graphQlFormatter';
import { createUnit } from 'util/unitConversion';

export const encodeSeasonHistory = (harvestHistory) => {
  // TODO -- change crop legacyId to id after we support loading in crop UUIDs.
  return stringify(
    Object.keys(harvestHistory).map(
      season => ({ season, crops: [{ legacyId: harvestHistory[season].cropId }] })
    )
  );
};

/**
 * Transform object with .q and .u members to format expected by graphQL
 * @param {Object} unitValue
 * @param {Number|string} unitValue.q
 * @param {string} unitValue.u
 * @return {String}
 */
export const encodeUnitValue = (unitValue) => {
  return stringify({ q: unitValue.q, u: new Enum(unitValue.u) });
};

export const hankifyScriptPlanDetails = ({
  harvestHistory = {},
  targetYield,
  jobId,
  seedCost,
  grainPrice,
  cropId,
  cropNominalWeight,
  bagSize,
  include,
  ...unconvertedDetails
}) => {
  const toUpdate = {};

  // Convert unit values to Hank-expected units.
  toUpdate.seasonData = encodeSeasonHistory(harvestHistory);

  toUpdate.targetYield = (targetYield && cropNominalWeight) ? encodeUnitValue({
    q: createUnit(targetYield.q, targetYield.u).to('kilogram/hectare', { cropNominalWeight }).scalar,
    u: 'kg_hectare' // hank expects this specific string for the unit
  }) : null;

  toUpdate.seedCost = (seedCost && bagSize) ? encodeUnitValue({
    q: createUnit(seedCost.q, seedCost.u).to('usd/k seed', { bagSize }).scalar,
    u: 'usd_thousand'
  }) : null;

  toUpdate.grainPrice = (grainPrice && cropId) ? encodeUnitValue({
    q: createUnit(grainPrice.q, grainPrice.u).to('usd/kg', { cropNominalWeight }).scalar,
    u: 'usd_kg'
  }) : null;

  // below are full statements, not values
  toUpdate.jobId = jobId ? `jobId: "${jobId}",` : '';
  toUpdate.include = include ? stringify(include) : '';

  return { ...unconvertedDetails, ...toUpdate };
};

export const generateHankAsyncScriptQuery = ({
  fieldUuid,
  jobId,
  targetYield,
  seedCost,
  grainPrice,
  numZones,
  include,
  seasonData,
  countryCode,
  agronomicSeason,
  sproutId
}) => {
  // TODO -- get a full graphql client we don't hate.  Use variables instead of interpolation
  const zoneArg = numZones ? `numberOfZones: ${numZones},` : '';
  const agronomicSeasonArg = agronomicSeason ? `agronomicSeason: ${agronomicSeason},` : '';
  const product = `product: {id: "${sproutId}" },`;
  const query = `
  {

  asyncRecommendation(
  target: {id:"${fieldUuid}", type: field}
  ${jobId}
  seedingArgs: {
              plantingScenario: {targetYield: ${targetYield},
                                 seedCost: ${seedCost},
                                 grainPrice: ${grainPrice},
                                ${product}
                                ${agronomicSeasonArg}
                                countryCode: ${countryCode}},
              ${zoneArg}
              include:  ${include},
              seasonData: ${seasonData}
  }) {
     status {
       jobId
       waitTime
     }
     recommendation {
       ... on seeding {
        highestEconomicField { ...blendedModelRate }
        densityCurveField {
          hardinParams {
            hardinParamsA
            hardinParamsB
          }
        }
        missingDataZoneExists
        defaultNumberOfZones
        type
        cciFailedLayers { layerSpec message status }
        yieldFailedLayers { layerSpec message status }
        features {
          type
          geometry { coordinates type }
          properties {
            highestEconomic { ...blendedModelRate }
            mediumEconomic { ...blendedModelRate }
            balancedEconomicYield { ...blendedModelRate }
            mediumYield { ...blendedModelRate }
            highestYield { ...blendedModelRate }
            missingData
          }
        }
      }
    }
  }
}

fragment blendedModelRate on blendedModelRate {
  estimatedProfit { q u }
  estimatedYield { q u }
  rate { q u }
}
  `;
  return query;
};

export const generateHankAsyncZoneGeneration = ({
  fieldUuid,
  jobId,
  include,
  seasonData,
  countryCode,
  agronomicSeason
}) => {
  // TODO -- get a full graphql client we don't hate.  Use variables instead of interpolation
  const query = `
  {

    asyncRecommendation(
      target: {id:"${fieldUuid}", type: field},
      ${jobId}
      seedingArgs: {
        include:  ${include},
        seasonData: ${seasonData},
        plantingScenario: {
          countryCode: ${countryCode},
          agronomicSeason: ${agronomicSeason}
        }
      }
    ) {
      status {
        jobId
        waitTime
        message
      }
    }
  }
  `;
  return query;
};
